var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.user.profile_image_url)?_c('img',{staticClass:"profile-image rounded-circle",style:(_vm.style),attrs:{"src":_vm.user.profile_image_url}}):_c('div',{staticClass:"profile-image rounded-circle profile-image-bg",style:(_vm.style)},[_vm._v(_vm._s(_vm.initials))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-160b2aaf","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/views/rd/assets/js/v2/components/misc/userImage.vue
// module id = 269N
// module chunks = 11 18 32